﻿import type { EventOrganizerType } from '@/types/base'
import { acceptHMRUpdate, defineStore } from 'pinia'
import type { Ref } from 'vue'
import { ref } from 'vue'
import { getAllEventOrganizerTypes } from '@/api'

export interface EventOrganizerTypeStore {
    eventOrganizerTypes: Ref<EventOrganizerType[]>
    loadAll(): Promise<void>
    getEventOrganizerType(id: number): EventOrganizerType | undefined
}

export const useEventOrganizerTypeStore = defineStore('eventOrganizerType', function (): EventOrganizerTypeStore {
    const eventOrganizerTypes = ref<EventOrganizerType[]>([])

    async function loadAll() {
        if (eventOrganizerTypes.value.length === 0) {
            eventOrganizerTypes.value = await getAllEventOrganizerTypes()
        }
    }

    function getEventOrganizerType(id: number): EventOrganizerType | undefined {
        return eventOrganizerTypes.value.find((x) => x.id === id) as EventOrganizerType | undefined
    }

    return { eventOrganizerTypes, getEventOrganizerType, loadAll }
})
// make sure to pass the right store definition, `useAuth` in this case.
if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useEventOrganizerTypeStore, import.meta.hot))
}
